export const getInitialStatus = status => status === 'suspended' ? 'unsuspend' : 'suspend';

export const getNewStatus = status => status === 'suspend' ? 'unsuspend' : 'suspend';

// E6 blocks the card after too many failed PIN entries; unlocking the PIN clears it.
export const isPinBlocked = status => status === 'pin_block';
